<div class="cm-canvas-with-ruler-container">
    <div>
        <div class="cm-ruler-corner" [matMenuTriggerFor]="rulerMenu">
            {{ $measurementUnit() }}
        </div>
    </div>
    <div>
        <cm-ruler
            #rulerX
            class="cm-ruler"
            orientation="horizontal"
            [pixelsPerUnit]="zoomedPixelsPerUnit()"
            [originOffset]="workspaceOffsetInUnits().x"
            [cursorPosition]="cursorPositionInUnits()?.x"
            [showCursorLabel]="$showCursorLabel()"
        ></cm-ruler>
    </div>
    <div>
        <cm-ruler
            #rulerY
            class="cm-ruler"
            orientation="vertical"
            [pixelsPerUnit]="zoomedPixelsPerUnit()"
            [originOffset]="workspaceOffsetInUnits().y"
            [cursorPosition]="cursorPositionInUnits()?.y"
            [showCursorLabel]="$showCursorLabel()"
        ></cm-ruler>
    </div>
    <div class="cm-canvas-container">
        <ng-content></ng-content>
    </div>
</div>

<mat-menu #rulerMenu="matMenu">
    @for (measurementUnitOption of $measurementUnitOptions(); track measurementUnitOption) {
        <button mat-menu-item (click)="$measurementUnit.set(measurementUnitOption)">
            <span>{{ measurementUnitOption }}</span>
        </button>
    }
    <mat-divider />
    <button mat-menu-item (click)="$showCursorLabel.set(!$showCursorLabel())">
        <span>{{ $showCursorLabel() ? "Hide cursor label" : "Show cursor label" }}</span>
    </button>
</mat-menu>
